// Modal backdrops are now rendered by React via ReactDOM.createPortal
// (e.g. `{isOpen && ReactDOM.createPortal(<div className="modal-backdrop ..."/>, document.body)}`).
// Manually removing `.modal-backdrop` here detaches a React-owned DOM node, so when the modal
// closes React's own removeChild throws `NotFoundError: Failed to execute 'removeChild' on 'Node'`,
// which surfaces as the "Something went wrong" error boundary on EVERY modal close (cancel or
// after submit success/failure). React fully owns the backdrop lifecycle, so we only reset the
// body scroll-lock state here. (Bootstrap offcanvas uses `.offcanvas-backdrop` and manages its
// own backdrop, so it is unaffected.)
export const cleanupModal = () => {
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
};
